/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { shieldLockPuzzleDuocolor } from "../assets/shield-lock-puzzle-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconShieldLockPuzzleDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={shieldLockPuzzleDuocolor.svg} />
);

IllustrativeIconShieldLockPuzzleDuocolor.displayName = "IllustrativeIconShieldLockPuzzleDuocolor";
